// extracted by mini-css-extract-plugin
export default {"card-inner-wrapper":"FontCard_card-inner-wrapper__-jbIO","font-family-wrapper":"FontCard_font-family-wrapper__itV3x","font-card-wrapper":"FontCard_font-card-wrapper__xowm2"};